var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSpoofed)?_c('div',{staticClass:"SPOOF-BADGE"},[_c('router-link',{attrs:{"to":{ name: 'login_as' }}},[_vm._v("SPOOFED")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }